<template>
  <div id="app">
    <header-nav></header-nav>
    <div class="content">
      <router-view/>
    </div>

    <!--<footer-content></footer-content>-->
  </div>
</template>

<script>
  // components
  import headerNav from '@/components/header.vue';
  // import footerContent from '@/components/footer.vue';
  export default {
    name: 'App',
    components: {
      headerNav,
      // footerContent
    },
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}


*{
  margin: 0;
  padding: 0;
}
html, body{
  width: 100%;
  height: 100%;
  min-width: 900px;
}

button{
  -webkit-tap-highlight-color:rgba(0,0,0,0);
}

a,a:hover,a:active,a:visited,a:link,a:focus{
  -webkit-tap-highlight-color:rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
  outline:none;
  background: none;
  text-decoration: none;
}

.product-detail .rich-text img{
  width: 100%!important;
}

  .header{

  }
  .content{
    flex:1;
    overflow: auto;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue